<template>
  <div class="brand-join-body">
    <!-- 微信认证组件 -->
    <wxAuth :share="share"></wxAuth>
    <div class="join-img-content">
      <img src="../../assets/images/join-back-01.png" alt="">
      <img src="../../assets/images/join-back-02.png" alt="">
    </div>
    <div class="join-form-body">
      <div class="form-content">
        <p class="form-content-title">品牌合作</p>
        <label>公司名称</label>
        <div class="field">
          <input type="text" v-model="tempForm.company" maxlength="30" placeholder="请输入公司名称">
          <span class="input-maxLength">{{tempForm.company.length}}/30</span>
        </div>
        <label>产品品牌</label>
        <div class="field">
          <input type="text" v-model="tempForm.brandName" maxlength="30" placeholder="请输入产品品牌">
          <span class="input-maxLength">{{tempForm.brandName.length}}/30</span>
        </div>
        <label>所属领域</label>
        <div class="field" @click="showBusinessScope">
          <van-row>
            <van-col :span="22" :style="{color: tempForm.businessScope.length === 0?'#C0C0C0':''}">{{tempForm.businessScope || '请选择所属领域'}}</van-col>
            <van-col :span="2"><span><van-icon name="arrow"/></span></van-col>
          </van-row>
        </div>
        <label>联系人</label>
        <div class="field">
          <input type="text" v-model="tempForm.contacts" maxlength="30" @focus="mobileFocus" @blur="mobileBlur" placeholder="请输入联系人（必填）">
        </div>
        <label>联系电话</label>
        <div class="field">
          <input type="text" v-model="tempForm.mobile" maxlength="12" @focus="mobileFocus" @blur="mobileBlur" placeholder="请输入联系电话（必填）">
        </div>
        <van-row class="service-process-button">
          <button @click="submit">我要合作</button>
        </van-row>
      </div>
      <img src="../../assets/images/service-process.png" class="service-process" alt="">
    </div>
    <div v-show="businessScopeShow" class="mask">
      <van-picker
        show-toolbar
        :columns="columns"
        @cancel="onCancel"
        @confirm="onConfirm"
        style="position: fixed; bottom: 0px; z-index: 2; left: 0; right: 0"
      />
    </div>
  </div>
</template>

<script>
import wxAuth from '@/components/wxAuth'
import { Toast, Dialog } from 'vant'
import { brandJoin } from '@/api/brand/brands'
export default {
  name: 'brand-join',
  components: { wxAuth },
  data () {
    return {
      share: {
        title: '河姆渡设计师之家品牌入驻',
        desc: '我们正在寻找优秀的解决方案供应商，为更多设计师服务！快来加入我们吧！',
        imgUrl: 'https://image01.homedo.com/Files/Images/cms/www/20190724/4791239174829293947_pic1.png',
        url: window.location.href.split('#')[0]
      },
      tempForm: {
        brandName: '',
        businessScope: '',
        company: '',
        contacts: '',
        introduction: '',
        mobile: ''
      },
      businessScopeShow: false,
      columns: ['智能楼宇', '文教卫', '公安', '司法', '交通', '能源', '其他'],
      scrollDelay: null
    }
  },
  methods: {
    showBusinessScope () {
      this.businessScopeShow = true
    },
    onConfirm (val) {
      this.tempForm.businessScope = val
      this.onCancel()
    },
    onCancel () {
      this.businessScopeShow = false
    },
    submit () {
      if (this.tempForm.contacts.trim() === '') {
        Toast('请输入联系人')
        return
      }
      if (this.tempForm.mobile.trim() === '') {
        Toast('请输入联系电话')
        return
      }
      const reg = /^(((0\d{2,3}-|0\d{2,4})\d{7,8})|(1[34578]\d{9})|(400-[0-9]{0,7}-[0-9]{1,7}))$/
      if (!reg.test(this.tempForm.mobile)) {
        Toast('请输入正确的联系电话')
        return
      }
      this.tempForm.introduction = this.tempForm.introduction.trim() !== '' ? this.tempForm.introduction.trim() : '暂无'
      let params = {
        brandName: this.tempForm.brandName.trim() || '暂无',
        businessScope: this.tempForm.businessScope.trim() || '暂无',
        company: this.tempForm.company.trim() || '暂无',
        introduction: this.tempForm.introduction.trim() || '暂无',
        contacts: this.tempForm.contacts.trim(),
        mobile: this.tempForm.mobile.trim()
      }

      brandJoin(params).then(result => {
        if (result.status === 200 && result.data && result.data.respCode === '0000') {
          Dialog.confirm({
            message: '您的橄榄枝我们已经收到了，方案馆的小芳和小岸会尽快联系您，预祝我们合作成功！'
          }).then(() => {
            this.reset()
          }).catch(() => {
            this.reset()
          })
        }
      })
    },
    mobileFocus () {
      if (this.scrollDelay !== null) {
        window.clearTimeout(this.scrollDelay)
        this.scrollDelay = null
      }
    },
    mobileBlur () {
      this.scrollDelay = window.setTimeout(() => {
        window.scroll(0, document.body.scrollHeight)
      }, 100)
    },
    reset () {
      this.tempForm = {
        brandName: '',
        businessScope: '',
        company: '',
        contacts: '',
        introduction: '',
        mobile: ''
      }
      window.scroll(0, 0)
    }
  }
}
</script>

<style lang="scss" scoped>
.brand-join-body{
  background: -webkit-linear-gradient(180deg,rgba(17,1,101,1) 0%,rgba(150,60,255,1) 100%);
  background: -o-linear-gradient(180deg,rgba(17,1,101,1) 0%,rgba(150,60,255,1) 100%);
  background: -moz-linear-gradient(180deg,rgba(17,1,101,1) 0%,rgba(150,60,255,1) 100%);
  background: linear-gradient(180deg,rgba(17,1,101,1) 0%,rgba(150,60,255,1) 100%);
  width: 100%;
  .join-img-content{
    font-size: 0px;
    margin: 0;
    padding: 0;
    img{
      margin: 0;
      padding: 0;
      width: 375px;
      height: auto;
    }
  }
  .join-form-body{
    width: 375px;
    padding: 12px 10px 0 10px;
    box-sizing: border-box;
    .form-content{
      padding-top: 25px;
      background-color: white;
      width: 355px;
      &-title{
       margin-bottom: 24px;
       position: relative;
       text-align: center;
       font-size:20px;
       font-weight:600;
       color:rgba(34,34,34,1);
       line-height:28px;
        &:before{
          position: absolute;
          left: 115px;
          top: 14px;
          content: '';
          width: 10px;
          height: 0px;
          border: 1px rgba(34,34,34,1) solid;
        }
        &:after{
           position: absolute;
           right: 115px;
           top: 14px;
           content: '';
           width: 10px;
           height: 0px;
           border: 1px rgba(34,34,34,1) solid;
         }
      }
      label{
        margin-left: 10px;
        font-weight: bold;
      }
      .field{
        height: 50px;
        line-height: 50px;
        margin: 10px 10px 16px;
        padding-left: 10px;
        background:rgba(248,248,248,1);
        border-radius:8px;
        input{
         width: 275px;
         border: none;
         background:rgba(248,248,248,1);
         border-radius:8px;
        }
        .input-maxLength{
          text-align: right;
          font-size:16px;
          font-weight:400;
          color:rgba(192,192,192,1);
          line-height:16px;
        }
        i{
          vertical-align: middle;
        }
      }
      .service-process-button{
        text-align: center;
        padding-bottom: 24px;
        button{
          width:233px;
          height:50px;
          background:linear-gradient(180deg,rgba(255,162,127,1) 0%,rgba(255,33,33,1) 100%);
          box-shadow:0px 2px 9px 0px rgba(255,66,56,0.9);
          border-radius:25px;
          border: none;
          font-size:20px;
          font-weight:500;
          color:rgba(255,255,255,1);
        }
      }
    }
  }
  .service-process{
    width: 355px;
    height: auto;
    margin-top: 12px;
    margin-bottom: 40px;
  }
  .mask{
    position: fixed; top: 0; bottom: 0; left: 0; right: 0;background: rgba(000,000,000,0.3); z-index: 1;
  }
}
::-webkit-input-placeholder { /* WebKit, Blink, Edge */
  color:   rgba(192,192,192,1);
}
:-moz-placeholder { /* Mozilla Firefox 4 to 18 */
  color:    rgba(192,192,192,1);
}
::-moz-placeholder { /* Mozilla Firefox 19+ */
  color:    rgba(192,192,192,1);
}
:-ms-input-placeholder { /* Internet Explorer 10-11 */
  color:    rgba(192,192,192,1);
}
</style>



// WEBPACK FOOTER //
// src/view/brand/join.vue